<template>
    <div>
      
      <div class="card border-0 text-center " >
      <img style="height: 100px;margin: 20px;" src="/img/exito.svg">
      <p class="fs-5 fw-bold">{{mensaje}}</p>
        <button @click="$router.push(ruta)"
                class="mt-5 btn fw-bold text-white form-control btn-info mb-3"
                style="background-color: #6f7fcc; border-color: #6f7fcc;">
                {{ boton }}
               </button>
      </div>
    </div>
  </template>
  
  <script>
  
  export default {
    name: "ModalInicio",
    components: {},
    
    props: [
      "trazado474",
      "grupo78Props",
      "grupo78Props2",
      "trazado477", 
      "trazado481",
      "grupo8",
      "grupo9",
      "messageProp",
     
    ],
    data() {
        return {
          mensaje: "La contraseña ha sido creada exitosamente.",
          ruta: "/login",
          boton: " Ir al inicio de sesión",
        }}
   
    
  };
  </script>
  
  <style>
  .card{
    background-color: #f5f6ff; 
  }
  .modal-body {
    position: relative;
    flex: 1 1 auto;
     padding:0 !important;
}
  .opcio1m{
    z-index:15;
  }
  
  .ha-superado-la-canti11m {
    height: 150px;
    left: 561px;
    letter-spacing: 0;
    line-height: 12px;
    position: absolute;
    text-align: center;
    top: 172px;
    z-index: 5;
    width: 800px;
  }
  .overlap-group1311m {
    height: 70px;
    left: 719px;
    position: absolute;
    top: 334px;
    width: 484px;
        z-index: 5;
  }
  .rectngulo-11a1m {
    background-color: var(--moody-blue);
    border-radius: 6.58px;
    height: 65px;
    left: 1px;
    position: absolute;
    top: 0;
    width: 479px;
  }
  
  .recuperar-contrasea51m {
    height: 67px;
    left: 0;
    letter-spacing: 0;
    line-height: 40.8px;
    position: absolute;
    text-align: center;
    top: 4px;
    width: 484px;
  }
  
  
  
  </style>
  